import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { setDataValue, getDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgFloor } from '../../fg-math.js';

const floorDef = {
  type: FgBlockType.Floor,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    setDataValue(ctx, block, "value", fgFloor(getDataValue(ctx, env, block, "a")));
  }
};

export { floorDef };
//# sourceMappingURL=floor.js.map
